import { createFileRoute } from "@tanstack/react-router";
import { SmsConfigPage } from "@/features/sms/config-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/sms")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.system.sms", location.pathname);
	},
	component: SmsConfigPage,
});
